<template>
  <router-view />
  <GlobalSuccessDialog />
</template>

<script>
// import AuthService from "./modules/auth/views/authService";
import  GlobalSuccessDialog  from "./components/GlobalSuccessDialog.vue";

export default {
  name: "MainPage",

  components: {GlobalSuccessDialog},

  data() {
    return {
      screenSize: "",
    };
  },

  computed: {},

  mounted() {
  
    this.checkScreenSize(); // Check screen size initially
    window.addEventListener("resize", this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      const isSmallScreen = window.matchMedia("(max-width: 768px)").matches;
      this.screenSize = isSmallScreen ? "Small" : "Large";

    },
  },

  watch: {},
};
</script>

<style>
/* @import url("./style.css"); */
</style>
